<template>
  <a :href="'tel:' + phone" class="call_to_book -text-blue">
    <span class="no_wrap">Call to book</span><br />
    <small class="text-blue">{{ phone }}</small>
  </a>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CallToBook",
  computed: {
    ...mapState(["client"]),
    phone() {
      return this.client.PublicPhoneNumber;
    }
  }
};
</script>

<style lang="scss" scoped>
.call_to_book {
  padding: 0 0 0 10px;
  text-align: right;
  span {
    font-size: 14px;
    font-weight: 500;
  }
  small {
    padding-top: 5px;
    display: block;
  }
}
</style>
